/* Reducer DATA — cities and categories, loaded once on app start */
const data = (state = null, action) => {

    switch (action.type) {

        case 'SET_DATA':
            return action.payload

        default:
            return state
    }
}

export default data
